/** Analytics Portal V1 — shared chart container (Phase 9). Owns the frame, heading,
 * description and the accessible summary slot so no chart component repeats them. */
import React from "react";
import { Card } from "@/components/ui/card";

export const ChartCard = ({ title, description, actions, summary, testId, children,
                            className = "" }) => (
  <Card className={`p-5 ${className}`} data-testid={testId}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <div>
        <h3 className="text-base font-[620] text-foreground">{title}</h3>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      {actions}
    </div>
    {summary && (
      <p className="sr-only" data-testid={testId ? `${testId}-summary` : undefined}>{summary}</p>
    )}
    <div className="mt-4">{children}</div>
  </Card>
);
